// A redirect target is only safe to treat as a same-origin path when it begins
// with a single "/". A leading "//" is a protocol-relative URL the browser
// resolves to an external origin ("//evil.com" -> "https://evil.com") — the
// open-redirect vector behind CVE-2026-40181. Backslashes are rejected
// anywhere in the path: browsers normalise "\" to "/" during URL parsing, so
// "/\evil.com" reaches the same protocol-relative form while passing a "//"
// prefix check (GHSA-wrjc-x8rr-h8h6), and no legitimate internal path contains
// one. Rejecting here covers every call site rather than relying on each to
// remember the check.
export function isSafeInternalPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//") && !path.includes("\\");
}
